import { titleFont, textSize, boldFont, zIndex } from 'styles/helpers'
import config from 'styles/config'

export default {
  container: {
    position: 'fixed',
    ...zIndex('console'),
    bottom: 0,
    left: 0,
    right: 0,
    maxHeight: '100%',
    overflowY: 'scroll',
    background: 'rgba(0, 0, 0, .8)',
    borderTop: '1px solid black',
    cursor: 'pointer',
  },
  title: {
    position: 'relative',
    padding: '10px 10px 12px 10px',
    borderTop: '1px solid #333',
    color: '#999',
    ...titleFont(),
    ...textSize(14, 16),
    textTransform: 'lowercase'
  },
  clearButton: {
    position: 'absolute',
    right: 10,
    top: 7,
    padding: '0 10px',
    background: '#333',
    color: '#FFF',
    ...boldFont(),
    ...textSize(13, 25),
    borderRadius: 8
  },
  message: {
    borderTop: '1px solid #333',
    padding: '8px 10px',
    color: '#FFF',
    ...textSize(13, 15),
  },
  number: {
    display: 'inline-block',
    width: 20,
    color: '#999',
    ...textSize(11, 15),
  },
  json: {
    padding: '6px 0',
    marginTop: 6,
    marginBottom: 6,
    marginLeft: 20,
    fontFamily: 'Monaco, Menlo, Consolas, "Courier New", monospace',
    ...textSize(11, 18),
    borderTop: '1px solid #222',
  }
}
